import { PayoutPanel } from "@/components/organisms";

export const Payout = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <PayoutPanel />
    </div>
  );
};
